var bundle =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * anime.js v3.0.1
 * (c) 2019 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */

// Defaults

var defaultInstanceSettings = {
  update: null,
  begin: null,
  loopBegin: null,
  changeBegin: null,
  change: null,
  changeComplete: null,
  loopComplete: null,
  complete: null,
  loop: 1,
  direction: 'normal',
  autoplay: true,
  timelineOffset: 0
};

var defaultTweenSettings = {
  duration: 1000,
  delay: 0,
  endDelay: 0,
  easing: 'easeOutElastic(1, .5)',
  round: 0
};

var validTransforms = ['translateX', 'translateY', 'translateZ', 'rotate', 'rotateX', 'rotateY', 'rotateZ', 'scale', 'scaleX', 'scaleY', 'scaleZ', 'skew', 'skewX', 'skewY', 'perspective'];

// Caching

var cache = {
  CSS: {},
  springs: {}
};

// Utils

function minMax(val, min, max) {
  return Math.min(Math.max(val, min), max);
}

function stringContains(str, text) {
  return str.indexOf(text) > -1;
}

function applyArguments(func, args) {
  return func.apply(null, args);
}

var is = {
  arr: function (a) { return Array.isArray(a); },
  obj: function (a) { return stringContains(Object.prototype.toString.call(a), 'Object'); },
  pth: function (a) { return is.obj(a) && a.hasOwnProperty('totalLength'); },
  svg: function (a) { return a instanceof SVGElement; },
  inp: function (a) { return a instanceof HTMLInputElement; },
  dom: function (a) { return a.nodeType || is.svg(a); },
  str: function (a) { return typeof a === 'string'; },
  fnc: function (a) { return typeof a === 'function'; },
  und: function (a) { return typeof a === 'undefined'; },
  hex: function (a) { return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a); },
  rgb: function (a) { return /^rgb/.test(a); },
  hsl: function (a) { return /^hsl/.test(a); },
  col: function (a) { return (is.hex(a) || is.rgb(a) || is.hsl(a)); },
  key: function (a) { return !defaultInstanceSettings.hasOwnProperty(a) && !defaultTweenSettings.hasOwnProperty(a) && a !== 'targets' && a !== 'keyframes'; }
};

// Easings

function parseEasingParameters(string) {
  var match = /\(([^)]+)\)/.exec(string);
  return match ? match[1].split(',').map(function (p) { return parseFloat(p); }) : [];
}

// Spring solver inspired by Webkit Copyright © 2016 Apple Inc. All rights reserved. https://webkit.org/demos/spring/spring.js

function spring(string, duration) {

  var params = parseEasingParameters(string);
  var mass = minMax(is.und(params[0]) ? 1 : params[0], .1, 100);
  var stiffness = minMax(is.und(params[1]) ? 100 : params[1], .1, 100);
  var damping = minMax(is.und(params[2]) ? 10 : params[2], .1, 100);
  var velocity =  minMax(is.und(params[3]) ? 0 : params[3], .1, 100);
  var w0 = Math.sqrt(stiffness / mass);
  var zeta = damping / (2 * Math.sqrt(stiffness * mass));
  var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
  var a = 1;
  var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;

  function solver(t) {
    var progress = duration ? (duration * t) / 1000 : t;
    if (zeta < 1) {
      progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
    } else {
      progress = (a + b * progress) * Math.exp(-progress * w0);
    }
    if (t === 0 || t === 1) { return t; }
    return 1 - progress;
  }

  function getDuration() {
    var cached = cache.springs[string];
    if (cached) { return cached; }
    var frame = 1/6;
    var elapsed = 0;
    var rest = 0;
    while(true) {
      elapsed += frame;
      if (solver(elapsed) === 1) {
        rest++;
        if (rest >= 16) { break; }
      } else {
        rest = 0;
      }
    }
    var duration = elapsed * frame * 1000;
    cache.springs[string] = duration;
    return duration;
  }

  return duration ? solver : getDuration;

}

// Elastic easing adapted from jQueryUI http://api.jqueryui.com/easings/

function elastic(amplitude, period) {
  if ( amplitude === void 0 ) amplitude = 1;
  if ( period === void 0 ) period = .5;

  var a = minMax(amplitude, 1, 10);
  var p = minMax(period, .1, 2);
  return function (t) {
    return (t === 0 || t === 1) ? t : 
      -a * Math.pow(2, 10 * (t - 1)) * Math.sin((((t - 1) - (p / (Math.PI * 2) * Math.asin(1 / a))) * (Math.PI * 2)) / p);
  }
}

// Basic steps easing implementation https://developer.mozilla.org/fr/docs/Web/CSS/transition-timing-function

function steps(steps) {
  if ( steps === void 0 ) steps = 10;

  return function (t) { return Math.round(t * steps) * (1 / steps); };
}

// BezierEasing https://github.com/gre/bezier-easing

var bezier = (function () {

  var kSplineTableSize = 11;
  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

  function A(aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1 }
  function B(aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1 }
  function C(aA1)      { return 3.0 * aA1 }

  function calcBezier(aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT }
  function getSlope(aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1) }

  function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX, currentT, i = 0;
    do {
      currentT = aA + (aB - aA) / 2.0;
      currentX = calcBezier(currentT, mX1, mX2) - aX;
      if (currentX > 0.0) { aB = currentT; } else { aA = currentT; }
    } while (Math.abs(currentX) > 0.0000001 && ++i < 10);
    return currentT;
  }

  function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < 4; ++i) {
      var currentSlope = getSlope(aGuessT, mX1, mX2);
      if (currentSlope === 0.0) { return aGuessT; }
      var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
  }

  function bezier(mX1, mY1, mX2, mY2) {

    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) { return; }
    var sampleValues = new Float32Array(kSplineTableSize);

    if (mX1 !== mY1 || mX2 !== mY2) {
      for (var i = 0; i < kSplineTableSize; ++i) {
        sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
      }
    }

    function getTForX(aX) {

      var intervalStart = 0;
      var currentSample = 1;
      var lastSample = kSplineTableSize - 1;

      for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += kSampleStepSize;
      }

      --currentSample;

      var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
      var guessForT = intervalStart + dist * kSampleStepSize;
      var initialSlope = getSlope(guessForT, mX1, mX2);

      if (initialSlope >= 0.001) {
        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
      } else if (initialSlope === 0.0) {
        return guessForT;
      } else {
        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
      }

    }

    return function (x) {
      if (mX1 === mY1 && mX2 === mY2) { return x; }
      if (x === 0 || x === 1) { return x; }
      return calcBezier(getTForX(x), mY1, mY2);
    }

  }

  return bezier;

})();

var penner = (function () {

  var names = ['Quad', 'Cubic', 'Quart', 'Quint', 'Sine', 'Expo', 'Circ', 'Back', 'Elastic'];

  // Approximated Penner equations http://matthewlein.com/ceaser/

  var curves = {
    In: [
      [0.550, 0.085, 0.680, 0.530], /* inQuad */
      [0.550, 0.055, 0.675, 0.190], /* inCubic */
      [0.895, 0.030, 0.685, 0.220], /* inQuart */
      [0.755, 0.050, 0.855, 0.060], /* inQuint */
      [0.470, 0.000, 0.745, 0.715], /* inSine */
      [0.950, 0.050, 0.795, 0.035], /* inExpo */
      [0.600, 0.040, 0.980, 0.335], /* inCirc */
      [0.600,-0.280, 0.735, 0.045], /* inBack */
      elastic /* inElastic */
    ],
    Out: [
      [0.250, 0.460, 0.450, 0.940], /* outQuad */
      [0.215, 0.610, 0.355, 1.000], /* outCubic */
      [0.165, 0.840, 0.440, 1.000], /* outQuart */
      [0.230, 1.000, 0.320, 1.000], /* outQuint */
      [0.390, 0.575, 0.565, 1.000], /* outSine */
      [0.190, 1.000, 0.220, 1.000], /* outExpo */
      [0.075, 0.820, 0.165, 1.000], /* outCirc */
      [0.175, 0.885, 0.320, 1.275], /* outBack */
      function (a, p) { return function (t) { return 1 - elastic(a, p)(1 - t); }; } /* outElastic */
    ],
    InOut: [
      [0.455, 0.030, 0.515, 0.955], /* inOutQuad */
      [0.645, 0.045, 0.355, 1.000], /* inOutCubic */
      [0.770, 0.000, 0.175, 1.000], /* inOutQuart */
      [0.860, 0.000, 0.070, 1.000], /* inOutQuint */
      [0.445, 0.050, 0.550, 0.950], /* inOutSine */
      [1.000, 0.000, 0.000, 1.000], /* inOutExpo */
      [0.785, 0.135, 0.150, 0.860], /* inOutCirc */
      [0.680,-0.550, 0.265, 1.550], /* inOutBack */
      function (a, p) { return function (t) { return t < .5 ? elastic(a, p)(t * 2) / 2 : 1 - elastic(a, p)(t * -2 + 2) / 2; }; } /* inOutElastic */
    ]
  };

  var eases = { 
    linear: [0.250, 0.250, 0.750, 0.750]
  };

  var loop = function ( coords ) {
    curves[coords].forEach(function (ease, i) {
      eases['ease'+coords+names[i]] = ease;
    });
  };

  for (var coords in curves) loop( coords );

  return eases;

})();

function parseEasings(easing, duration) {
  if (is.fnc(easing)) { return easing; }
  var name = easing.split('(')[0];
  var ease = penner[name];
  var args = parseEasingParameters(easing);
  switch (name) {
    case 'spring' : return spring(easing, duration);
    case 'cubicBezier' : return applyArguments(bezier, args);
    case 'steps' : return applyArguments(steps, args);
    default : return is.fnc(ease) ? applyArguments(ease, args) : applyArguments(bezier, ease);
  }
}

// Strings

function selectString(str) {
  try {
    var nodes = document.querySelectorAll(str);
    return nodes;
  } catch(e) {
    return;
  }
}

// Arrays

function filterArray(arr, callback) {
  var len = arr.length;
  var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
  var result = [];
  for (var i = 0; i < len; i++) {
    if (i in arr) {
      var val = arr[i];
      if (callback.call(thisArg, val, i, arr)) {
        result.push(val);
      }
    }
  }
  return result;
}

function flattenArray(arr) {
  return arr.reduce(function (a, b) { return a.concat(is.arr(b) ? flattenArray(b) : b); }, []);
}

function toArray(o) {
  if (is.arr(o)) { return o; }
  if (is.str(o)) { o = selectString(o) || o; }
  if (o instanceof NodeList || o instanceof HTMLCollection) { return [].slice.call(o); }
  return [o];
}

function arrayContains(arr, val) {
  return arr.some(function (a) { return a === val; });
}

// Objects

function cloneObject(o) {
  var clone = {};
  for (var p in o) { clone[p] = o[p]; }
  return clone;
}

function replaceObjectProps(o1, o2) {
  var o = cloneObject(o1);
  for (var p in o1) { o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p]; }
  return o;
}

function mergeObjects(o1, o2) {
  var o = cloneObject(o1);
  for (var p in o2) { o[p] = is.und(o1[p]) ? o2[p] : o1[p]; }
  return o;
}

// Colors

function rgbToRgba(rgbValue) {
  var rgb = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(rgbValue);
  return rgb ? ("rgba(" + (rgb[1]) + ",1)") : rgbValue;
}

function hexToRgba(hexValue) {
  var rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  var hex = hexValue.replace(rgx, function (m, r, g, b) { return r + r + g + g + b + b; } );
  var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  var r = parseInt(rgb[1], 16);
  var g = parseInt(rgb[2], 16);
  var b = parseInt(rgb[3], 16);
  return ("rgba(" + r + "," + g + "," + b + ",1)");
}

function hslToRgba(hslValue) {
  var hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hslValue) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(hslValue);
  var h = parseInt(hsl[1], 10) / 360;
  var s = parseInt(hsl[2], 10) / 100;
  var l = parseInt(hsl[3], 10) / 100;
  var a = hsl[4] || 1;
  function hue2rgb(p, q, t) {
    if (t < 0) { t += 1; }
    if (t > 1) { t -= 1; }
    if (t < 1/6) { return p + (q - p) * 6 * t; }
    if (t < 1/2) { return q; }
    if (t < 2/3) { return p + (q - p) * (2/3 - t) * 6; }
    return p;
  }
  var r, g, b;
  if (s == 0) {
    r = g = b = l;
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1/3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1/3);
  }
  return ("rgba(" + (r * 255) + "," + (g * 255) + "," + (b * 255) + "," + a + ")");
}

function colorToRgb(val) {
  if (is.rgb(val)) { return rgbToRgba(val); }
  if (is.hex(val)) { return hexToRgba(val); }
  if (is.hsl(val)) { return hslToRgba(val); }
}

// Units

function getUnit(val) {
  var split = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(val);
  if (split) { return split[2]; }
}

function getTransformUnit(propName) {
  if (stringContains(propName, 'translate') || propName === 'perspective') { return 'px'; }
  if (stringContains(propName, 'rotate') || stringContains(propName, 'skew')) { return 'deg'; }
}

// Values

function getFunctionValue(val, animatable) {
  if (!is.fnc(val)) { return val; }
  return val(animatable.target, animatable.id, animatable.total);
}

function getAttribute(el, prop) {
  return el.getAttribute(prop);
}

function convertPxToUnit(el, value, unit) {
  var valueUnit = getUnit(value);
  if (arrayContains([unit, 'deg', 'rad', 'turn'], valueUnit)) { return value; }
  var cached = cache.CSS[value + unit];
  if (!is.und(cached)) { return cached; }
  var baseline = 100;
  var tempEl = document.createElement(el.tagName);
  var parentEl = (el.parentNode && (el.parentNode !== document)) ? el.parentNode : document.body;
  parentEl.appendChild(tempEl);
  tempEl.style.position = 'absolute';
  tempEl.style.width = baseline + unit;
  var factor = baseline / tempEl.offsetWidth;
  parentEl.removeChild(tempEl);
  var convertedUnit = factor * parseFloat(value);
  cache.CSS[value + unit] = convertedUnit;
  return convertedUnit;
}

function getCSSValue(el, prop, unit) {
  if (prop in el.style) {
    var uppercasePropName = prop.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    var value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || '0';
    return unit ? convertPxToUnit(el, value, unit) : value;
  }
}

function getAnimationType(el, prop) {
  if (is.dom(el) && !is.inp(el) && (getAttribute(el, prop) || (is.svg(el) && el[prop]))) { return 'attribute'; }
  if (is.dom(el) && arrayContains(validTransforms, prop)) { return 'transform'; }
  if (is.dom(el) && (prop !== 'transform' && getCSSValue(el, prop))) { return 'css'; }
  if (el[prop] != null) { return 'object'; }
}

function getElementTransforms(el) {
  if (!is.dom(el)) { return; }
  var str = el.style.transform || '';
  var reg  = /(\w+)\(([^)]*)\)/g;
  var transforms = new Map();
  var m; while (m = reg.exec(str)) { transforms.set(m[1], m[2]); }
  return transforms;
}

function getTransformValue(el, propName, animatable, unit) {
  var defaultVal = stringContains(propName, 'scale') ? 1 : 0 + getTransformUnit(propName);
  var value = getElementTransforms(el).get(propName) || defaultVal;
  if (animatable) {
    animatable.transforms.list.set(propName, value);
    animatable.transforms['last'] = propName;
  }
  return unit ? convertPxToUnit(el, value, unit) : value;
}

function getOriginalTargetValue(target, propName, unit, animatable) {
  switch (getAnimationType(target, propName)) {
    case 'transform': return getTransformValue(target, propName, animatable, unit);
    case 'css': return getCSSValue(target, propName, unit);
    case 'attribute': return getAttribute(target, propName);
    default: return target[propName] || 0;
  }
}

function getRelativeValue(to, from) {
  var operator = /^(\*=|\+=|-=)/.exec(to);
  if (!operator) { return to; }
  var u = getUnit(to) || 0;
  var x = parseFloat(from);
  var y = parseFloat(to.replace(operator[0], ''));
  switch (operator[0][0]) {
    case '+': return x + y + u;
    case '-': return x - y + u;
    case '*': return x * y + u;
  }
}

function validateValue(val, unit) {
  if (is.col(val)) { return colorToRgb(val); }
  var originalUnit = getUnit(val);
  var unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;
  return unit && !/\s/g.test(val) ? unitLess + unit : unitLess;
}

// getTotalLength() equivalent for circle, rect, polyline, polygon and line shapes
// adapted from https://gist.github.com/SebLambla/3e0550c496c236709744

function getDistance(p1, p2) {
  return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}

function getCircleLength(el) {
  return Math.PI * 2 * getAttribute(el, 'r');
}

function getRectLength(el) {
  return (getAttribute(el, 'width') * 2) + (getAttribute(el, 'height') * 2);
}

function getLineLength(el) {
  return getDistance(
    {x: getAttribute(el, 'x1'), y: getAttribute(el, 'y1')}, 
    {x: getAttribute(el, 'x2'), y: getAttribute(el, 'y2')}
  );
}

function getPolylineLength(el) {
  var points = el.points;
  var totalLength = 0;
  var previousPos;
  for (var i = 0 ; i < points.numberOfItems; i++) {
    var currentPos = points.getItem(i);
    if (i > 0) { totalLength += getDistance(previousPos, currentPos); }
    previousPos = currentPos;
  }
  return totalLength;
}

function getPolygonLength(el) {
  var points = el.points;
  return getPolylineLength(el) + getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
}

// Path animation

function getTotalLength(el) {
  if (el.getTotalLength) { return el.getTotalLength(); }
  switch(el.tagName.toLowerCase()) {
    case 'circle': return getCircleLength(el);
    case 'rect': return getRectLength(el);
    case 'line': return getLineLength(el);
    case 'polyline': return getPolylineLength(el);
    case 'polygon': return getPolygonLength(el);
  }
}

function setDashoffset(el) {
  var pathLength = getTotalLength(el);
  el.setAttribute('stroke-dasharray', pathLength);
  return pathLength;
}

// Motion path

function getParentSvgEl(el) {
  var parentEl = el.parentNode;
  while (is.svg(parentEl)) {
    parentEl = parentEl.parentNode;
    if (!is.svg(parentEl.parentNode)) { break; }
  }
  return parentEl;
}

function getParentSvg(pathEl, svgData) {
  var svg = svgData || {};
  var parentSvgEl = svg.el || getParentSvgEl(pathEl);
  var rect = parentSvgEl.getBoundingClientRect();
  var viewBoxAttr = getAttribute(parentSvgEl, 'viewBox');
  var width = rect.width;
  var height = rect.height;
  var viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(' ') : [0, 0, width, height]);
  return {
    el: parentSvgEl,
    viewBox: viewBox,
    x: viewBox[0] / 1,
    y: viewBox[1] / 1,
    w: width / viewBox[2],
    h: height / viewBox[3]
  }
}

function getPath(path, percent) {
  var pathEl = is.str(path) ? selectString(path)[0] : path;
  var p = percent || 100;
  return function(property) {
    return {
      property: property,
      el: pathEl,
      svg: getParentSvg(pathEl),
      totalLength: getTotalLength(pathEl) * (p / 100)
    }
  }
}

function getPathProgress(path, progress) {
  function point(offset) {
    if ( offset === void 0 ) offset = 0;

    var l = progress + offset >= 1 ? progress + offset : 0;
    return path.el.getPointAtLength(l);
  }
  var svg = getParentSvg(path.el, path.svg);
  var p = point();
  var p0 = point(-1);
  var p1 = point(+1);
  switch (path.property) {
    case 'x': return (p.x - svg.x) * svg.w;
    case 'y': return (p.y - svg.y) * svg.h;
    case 'angle': return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
  }
}

// Decompose value

function decomposeValue(val, unit) {
  var rgx = /-?\d*\.?\d+/g;
  var value = validateValue((is.pth(val) ? val.totalLength : val), unit) + '';
  return {
    original: value,
    numbers: value.match(rgx) ? value.match(rgx).map(Number) : [0],
    strings: (is.str(val) || unit) ? value.split(rgx) : []
  }
}

// Animatables

function parseTargets(targets) {
  var targetsArray = targets ? (flattenArray(is.arr(targets) ? targets.map(toArray) : toArray(targets))) : [];
  return filterArray(targetsArray, function (item, pos, self) { return self.indexOf(item) === pos; });
}

function getAnimatables(targets) {
  var parsed = parseTargets(targets);
  return parsed.map(function (t, i) {
    return {target: t, id: i, total: parsed.length, transforms: { list: getElementTransforms(t) } };
  });
}

// Properties

function normalizePropertyTweens(prop, tweenSettings) {
  var settings = cloneObject(tweenSettings);
  // Override duration if easing is a spring
  if (/^spring/.test(settings.easing)) { settings.duration = spring(settings.easing); }
  if (is.arr(prop)) {
    var l = prop.length;
    var isFromTo = (l === 2 && !is.obj(prop[0]));
    if (!isFromTo) {
      // Duration divided by the number of tweens
      if (!is.fnc(tweenSettings.duration)) { settings.duration = tweenSettings.duration / l; }
    } else {
      // Transform [from, to] values shorthand to a valid tween value
      prop = {value: prop};
    }
  }
  var propArray = is.arr(prop) ? prop : [prop];
  return propArray.map(function (v, i) {
    var obj = (is.obj(v) && !is.pth(v)) ? v : {value: v};
    // Default delay value should only be applied to the first tween
    if (is.und(obj.delay)) { obj.delay = !i ? tweenSettings.delay : 0; }
    // Default endDelay value should only be applied to the last tween
    if (is.und(obj.endDelay)) { obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0; }
    return obj;
  }).map(function (k) { return mergeObjects(k, settings); });
}


function flattenKeyframes(keyframes) {
  var propertyNames = filterArray(flattenArray(keyframes.map(function (key) { return Object.keys(key); })), function (p) { return is.key(p); })
  .reduce(function (a,b) { if (a.indexOf(b) < 0) { a.push(b); } return a; }, []);
  var properties = {};
  var loop = function ( i ) {
    var propName = propertyNames[i];
    properties[propName] = keyframes.map(function (key) {
      var newKey = {};
      for (var p in key) {
        if (is.key(p)) {
          if (p == propName) { newKey.value = key[p]; }
        } else {
          newKey[p] = key[p];
        }
      }
      return newKey;
    });
  };

  for (var i = 0; i < propertyNames.length; i++) loop( i );
  return properties;
}

function getProperties(tweenSettings, params) {
  var properties = [];
  var keyframes = params.keyframes;
  if (keyframes) { params = mergeObjects(flattenKeyframes(keyframes), params); }
  for (var p in params) {
    if (is.key(p)) {
      properties.push({
        name: p,
        tweens: normalizePropertyTweens(params[p], tweenSettings)
      });
    }
  }
  return properties;
}

// Tweens

function normalizeTweenValues(tween, animatable) {
  var t = {};
  for (var p in tween) {
    var value = getFunctionValue(tween[p], animatable);
    if (is.arr(value)) {
      value = value.map(function (v) { return getFunctionValue(v, animatable); });
      if (value.length === 1) { value = value[0]; }
    }
    t[p] = value;
  }
  t.duration = parseFloat(t.duration);
  t.delay = parseFloat(t.delay);
  return t;
}

function normalizeTweens(prop, animatable) {
  var previousTween;
  return prop.tweens.map(function (t) {
    var tween = normalizeTweenValues(t, animatable);
    var tweenValue = tween.value;
    var to = is.arr(tweenValue) ? tweenValue[1] : tweenValue;
    var toUnit = getUnit(to);
    var originalValue = getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
    var previousValue = previousTween ? previousTween.to.original : originalValue;
    var from = is.arr(tweenValue) ? tweenValue[0] : previousValue;
    var fromUnit = getUnit(from) || getUnit(originalValue);
    var unit = toUnit || fromUnit;
    if (is.und(to)) { to = previousValue; }
    tween.from = decomposeValue(from, unit);
    tween.to = decomposeValue(getRelativeValue(to, from), unit);
    tween.start = previousTween ? previousTween.end : 0;
    tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
    tween.easing = parseEasings(tween.easing, tween.duration);
    tween.isPath = is.pth(tweenValue);
    tween.isColor = is.col(tween.from.original);
    if (tween.isColor) { tween.round = 1; }
    previousTween = tween;
    return tween;
  });
}

// Tween progress

var setProgressValue = {
  css: function (t, p, v) { return t.style[p] = v; },
  attribute: function (t, p, v) { return t.setAttribute(p, v); },
  object: function (t, p, v) { return t[p] = v; },
  transform: function (t, p, v, transforms, manual) {
    transforms.list.set(p, v);
    if (p === transforms.last || manual) {
      var str = '';
      transforms.list.forEach(function (value, prop) { str += prop + "(" + value + ") "; });
      t.style.transform = str;
    }
  }
};

// Set Value helper

function setTargetsValue(targets, properties) {
  var animatables = getAnimatables(targets);
  animatables.forEach(function (animatable) {
    for (var property in properties) {
      var value = getFunctionValue(properties[property], animatable);
      var target = animatable.target;
      var valueUnit = getUnit(value);
      var originalValue = getOriginalTargetValue(target, property, valueUnit, animatable);
      var unit = valueUnit || getUnit(originalValue);
      var to = getRelativeValue(validateValue(value, unit), originalValue);
      var animType = getAnimationType(target, property);
      setProgressValue[animType](target, property, to, animatable.transforms, true);
    }
  });
}

// Animations

function createAnimation(animatable, prop) {
  var animType = getAnimationType(animatable.target, prop.name);
  if (animType) {
    var tweens = normalizeTweens(prop, animatable);
    var lastTween = tweens[tweens.length - 1];
    return {
      type: animType,
      property: prop.name,
      animatable: animatable,
      tweens: tweens,
      duration: lastTween.end,
      delay: tweens[0].delay,
      endDelay: lastTween.endDelay
    }
  }
}

function getAnimations(animatables, properties) {
  return filterArray(flattenArray(animatables.map(function (animatable) {
    return properties.map(function (prop) {
      return createAnimation(animatable, prop);
    });
  })), function (a) { return !is.und(a); });
}

// Create Instance

function getInstanceTimings(animations, tweenSettings) {
  var animLength = animations.length;
  var getTlOffset = function (anim) { return anim.timelineOffset ? anim.timelineOffset : 0; };
  var timings = {};
  timings.duration = animLength ? Math.max.apply(Math, animations.map(function (anim) { return getTlOffset(anim) + anim.duration; })) : tweenSettings.duration;
  timings.delay = animLength ? Math.min.apply(Math, animations.map(function (anim) { return getTlOffset(anim) + anim.delay; })) : tweenSettings.delay;
  timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map(function (anim) { return getTlOffset(anim) + anim.duration - anim.endDelay; })) : tweenSettings.endDelay;
  return timings;
}

var instanceID = 0;

function createNewInstance(params) {
  var instanceSettings = replaceObjectProps(defaultInstanceSettings, params);
  var tweenSettings = replaceObjectProps(defaultTweenSettings, params);
  var properties = getProperties(tweenSettings, params);
  var animatables = getAnimatables(params.targets);
  var animations = getAnimations(animatables, properties);
  var timings = getInstanceTimings(animations, tweenSettings);
  var id = instanceID;
  instanceID++;
  return mergeObjects(instanceSettings, {
    id: id,
    children: [],
    animatables: animatables,
    animations: animations,
    duration: timings.duration,
    delay: timings.delay,
    endDelay: timings.endDelay
  });
}

// Core

var activeInstances = [];
var pausedInstances = [];
var raf;

var engine = (function () {
  function play() { 
    raf = requestAnimationFrame(step);
  }
  function step(t) {
    var activeInstancesLength = activeInstances.length;
    if (activeInstancesLength) {
      var i = 0;
      while (i < activeInstancesLength) {
        var activeInstance = activeInstances[i];
        if (!activeInstance.paused) {
          activeInstance.tick(t);
        } else {
          var instanceIndex = activeInstances.indexOf(activeInstance);
          if (instanceIndex > -1) {
            activeInstances.splice(instanceIndex, 1);
            activeInstancesLength = activeInstances.length;
          }
        }
        i++;
      }
      play();
    } else {
      raf = cancelAnimationFrame(raf);
    }
  }
  return play;
})();

function handleVisibilityChange() {
  if (document.hidden) {
    activeInstances.forEach(function (ins) { return ins.pause(); });
    pausedInstances = activeInstances.slice(0);
    activeInstances = [];
  } else {
    pausedInstances.forEach(function (ins) { return ins.play(); });
  }
}

if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', handleVisibilityChange);
}

// Public Instance

function anime(params) {
  if ( params === void 0 ) params = {};


  var startTime = 0, lastTime = 0, now = 0;
  var children, childrenLength = 0;
  var resolve = null;

  function makePromise(instance) {
    var promise = window.Promise && new Promise(function (_resolve) { return resolve = _resolve; });
    instance.finished = promise;
    return promise;
  }

  var instance = createNewInstance(params);
  var promise = makePromise(instance);

  function toggleInstanceDirection() {
    var direction = instance.direction;
    if (direction !== 'alternate') {
      instance.direction = direction !== 'normal' ? 'normal' : 'reverse';
    }
    instance.reversed = !instance.reversed;
    children.forEach(function (child) { return child.reversed = instance.reversed; });
  }

  function adjustTime(time) {
    return instance.reversed ? instance.duration - time : time;
  }

  function resetTime() {
    startTime = 0;
    lastTime = adjustTime(instance.currentTime) * (1 / anime.speed);
  }

  function seekCild(time, child) {
    if (child) { child.seek(time - child.timelineOffset); }
  }

  function syncInstanceChildren(time) {
    if (!instance.reversePlayback) {
      for (var i = 0; i < childrenLength; i++) { seekCild(time, children[i]); }
    } else {
      for (var i$1 = childrenLength; i$1--;) { seekCild(time, children[i$1]); }
    }
  }

  function setAnimationsProgress(insTime) {
    var i = 0;
    var animations = instance.animations;
    var animationsLength = animations.length;
    while (i < animationsLength) {
      var anim = animations[i];
      var animatable = anim.animatable;
      var tweens = anim.tweens;
      var tweenLength = tweens.length - 1;
      var tween = tweens[tweenLength];
      // Only check for keyframes if there is more than one tween
      if (tweenLength) { tween = filterArray(tweens, function (t) { return (insTime < t.end); })[0] || tween; }
      var elapsed = minMax(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
      var eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
      var strings = tween.to.strings;
      var round = tween.round;
      var numbers = [];
      var toNumbersLength = tween.to.numbers.length;
      var progress = (void 0);
      for (var n = 0; n < toNumbersLength; n++) {
        var value = (void 0);
        var toNumber = tween.to.numbers[n];
        var fromNumber = tween.from.numbers[n] || 0;
        if (!tween.isPath) {
          value = fromNumber + (eased * (toNumber - fromNumber));
        } else {
          value = getPathProgress(tween.value, eased * toNumber);
        }
        if (round) {
          if (!(tween.isColor && n > 2)) {
            value = Math.round(value * round) / round;
          }
        }
        numbers.push(value);
      }
      // Manual Array.reduce for better performances
      var stringsLength = strings.length;
      if (!stringsLength) {
        progress = numbers[0];
      } else {
        progress = strings[0];
        for (var s = 0; s < stringsLength; s++) {
          var a = strings[s];
          var b = strings[s + 1];
          var n$1 = numbers[s];
          if (!isNaN(n$1)) {
            if (!b) {
              progress += n$1 + ' ';
            } else {
              progress += n$1 + b;
            }
          }
        }
      }
      setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
      anim.currentValue = progress;
      i++;
    }
  }

  function setCallback(cb) {
    if (instance[cb] && !instance.passThrough) { instance[cb](instance); }
  }

  function countIteration() {
    if (instance.remaining && instance.remaining !== true) {
      instance.remaining--;
    }
  }

  function setInstanceProgress(engineTime) {
    var insDuration = instance.duration;
    var insDelay = instance.delay;
    var insEndDelay = insDuration - instance.endDelay;
    var insTime = adjustTime(engineTime);
    instance.progress = minMax((insTime / insDuration) * 100, 0, 100);
    instance.reversePlayback = insTime < instance.currentTime;
    if (children) { syncInstanceChildren(insTime); }
    if (!instance.began && instance.currentTime > 0) {
      instance.began = true;
      setCallback('begin');
      setCallback('loopBegin');
    }
    if (insTime <= insDelay && instance.currentTime !== 0) {
      setAnimationsProgress(0);
    }
    if ((insTime >= insEndDelay && instance.currentTime !== insDuration) || !insDuration) {
      setAnimationsProgress(insDuration);
    }
    if (insTime > insDelay && insTime < insEndDelay) {
      if (!instance.changeBegan) {
        instance.changeBegan = true;
        instance.changeCompleted = false;
        setCallback('changeBegin');
      }
      setCallback('change');
      setAnimationsProgress(insTime);
    } else {
      if (instance.changeBegan) {
        instance.changeCompleted = true;
        instance.changeBegan = false;
        setCallback('changeComplete');
      }
    }
    instance.currentTime = minMax(insTime, 0, insDuration);
    if (instance.began) { setCallback('update'); }
    if (engineTime >= insDuration) {
      lastTime = 0;
      countIteration();
      if (instance.remaining) {
        startTime = now;
        setCallback('loopComplete');
        setCallback('loopBegin');
        if (instance.direction === 'alternate') { toggleInstanceDirection(); }
      } else {
        instance.paused = true;
        if (!instance.completed) {
          instance.completed = true;
          setCallback('loopComplete');
          setCallback('complete');
          if (!instance.passThrough && 'Promise' in window) {
            resolve();
            promise = makePromise(instance);
          }
        }
      }
    }
  }

  instance.reset = function() {
    var direction = instance.direction;
    instance.passThrough = false;
    instance.currentTime = 0;
    instance.progress = 0;
    instance.paused = true;
    instance.began = false;
    instance.changeBegan = false;
    instance.completed = false;
    instance.changeCompleted = false;
    instance.reversePlayback = false;
    instance.reversed = direction === 'reverse';
    instance.remaining = instance.loop;
    children = instance.children;
    childrenLength = children.length;
    for (var i = childrenLength; i--;) { instance.children[i].reset(); }
    if (instance.reversed && instance.loop !== true || (direction === 'alternate' && instance.loop === 1)) { instance.remaining++; }
    setAnimationsProgress(0);
  };

  // Set Value helper

  instance.set = function(targets, properties) {
    setTargetsValue(targets, properties);
    return instance;
  };

  instance.tick = function(t) {
    now = t;
    if (!startTime) { startTime = now; }
    setInstanceProgress((now + (lastTime - startTime)) * anime.speed);
  };

  instance.seek = function(time) {
    setInstanceProgress(adjustTime(time));
  };

  instance.pause = function() {
    instance.paused = true;
    resetTime();
  };

  instance.play = function() {
    if (!instance.paused) { return; }
    if (instance.completed) { instance.reset(); }
    instance.paused = false;
    activeInstances.push(instance);
    resetTime();
    if (!raf) { engine(); }
  };

  instance.reverse = function() {
    toggleInstanceDirection();
    resetTime();
  };

  instance.restart = function() {
    instance.reset();
    instance.play();
  };

  instance.reset();

  if (instance.autoplay) { instance.play(); }

  return instance;

}

// Remove targets from animation

function removeTargetsFromAnimations(targetsArray, animations) {
  for (var a = animations.length; a--;) {
    if (arrayContains(targetsArray, animations[a].animatable.target)) {
      animations.splice(a, 1);
    }
  }
}

function removeTargets(targets) {
  var targetsArray = parseTargets(targets);
  for (var i = activeInstances.length; i--;) {
    var instance = activeInstances[i];
    var animations = instance.animations;
    var children = instance.children;
    removeTargetsFromAnimations(targetsArray, animations);
    for (var c = children.length; c--;) {
      var child = children[c];
      var childAnimations = child.animations;
      removeTargetsFromAnimations(targetsArray, childAnimations);
      if (!childAnimations.length && !child.children.length) { children.splice(c, 1); }
    }
    if (!animations.length && !children.length) { instance.pause(); }
  }
}

// Stagger helpers

function stagger(val, params) {
  if ( params === void 0 ) params = {};

  var direction = params.direction || 'normal';
  var easing = params.easing ? parseEasings(params.easing) : null;
  var grid = params.grid;
  var axis = params.axis;
  var fromIndex = params.from || 0;
  var fromFirst = fromIndex === 'first';
  var fromCenter = fromIndex === 'center';
  var fromLast = fromIndex === 'last';
  var isRange = is.arr(val);
  var val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
  var val2 = isRange ? parseFloat(val[1]) : 0;
  var unit = getUnit(isRange ? val[1] : val) || 0;
  var start = params.start || 0 + (isRange ? val1 : 0);
  var values = [];
  var maxValue = 0;
  return function (el, i, t) {
    if (fromFirst) { fromIndex = 0; }
    if (fromCenter) { fromIndex = (t - 1) / 2; }
    if (fromLast) { fromIndex = t - 1; }
    if (!values.length) {
      for (var index = 0; index < t; index++) {
        if (!grid) {
          values.push(Math.abs(fromIndex - index));
        } else {
          var fromX = !fromCenter ? fromIndex%grid[0] : (grid[0]-1)/2;
          var fromY = !fromCenter ? Math.floor(fromIndex/grid[0]) : (grid[1]-1)/2;
          var toX = index%grid[0];
          var toY = Math.floor(index/grid[0]);
          var distanceX = fromX - toX;
          var distanceY = fromY - toY;
          var value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
          if (axis === 'x') { value = -distanceX; }
          if (axis === 'y') { value = -distanceY; }
          values.push(value);
        }
        maxValue = Math.max.apply(Math, values);
      }
      if (easing) { values = values.map(function (val) { return easing(val / maxValue) * maxValue; }); }
      if (direction === 'reverse') { values = values.map(function (val) { return axis ? (val < 0) ? val * -1 : -val : Math.abs(maxValue - val); }); }
    }
    var spacing = isRange ? (val2 - val1) / maxValue : val1;
    return start + (spacing * (Math.round(values[i] * 100) / 100)) + unit;
  }
}

// Timeline

function timeline(params) {
  if ( params === void 0 ) params = {};

  var tl = anime(params);
  tl.duration = 0;
  tl.add = function(instanceParams, timelineOffset) {
    var tlIndex = activeInstances.indexOf(tl);
    var children = tl.children;
    if (tlIndex > -1) { activeInstances.splice(tlIndex, 1); }
    function passThrough(ins) { ins.passThrough = true; }
    for (var i = 0; i < children.length; i++) { passThrough(children[i]); }
    var insParams = mergeObjects(instanceParams, replaceObjectProps(defaultTweenSettings, params));
    insParams.targets = insParams.targets || params.targets;
    var tlDuration = tl.duration;
    insParams.autoplay = false;
    insParams.direction = tl.direction;
    insParams.timelineOffset = is.und(timelineOffset) ? tlDuration : getRelativeValue(timelineOffset, tlDuration);
    passThrough(tl);
    tl.seek(insParams.timelineOffset);
    var ins = anime(insParams);
    passThrough(ins);
    children.push(ins);
    var timings = getInstanceTimings(children, params);
    tl.delay = timings.delay;
    tl.endDelay = timings.endDelay;
    tl.duration = timings.duration;
    tl.seek(0);
    tl.reset();
    if (tl.autoplay) { tl.play(); }
    return tl;
  };
  return tl;
}

anime.version = '3.0.1';
anime.speed = 1;
anime.running = activeInstances;
anime.remove = removeTargets;
anime.get = getOriginalTargetValue;
anime.set = setTargetsValue;
anime.convertPx = convertPxToUnit;
anime.path = getPath;
anime.setDashoffset = setDashoffset;
anime.stagger = stagger;
anime.timeline = timeline;
anime.easing = parseEasings;
anime.penner = penner;
anime.random = function (min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; };

/* harmony default export */ __webpack_exports__["a"] = (anime);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return availFloors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapLabels; });
/* unused harmony export amenityGallery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return staticMapLabels; });
/* unused harmony export availabilityLabels */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return availabilityGallery; });
var availFloors = [{
	floor: 'Eighth (NW)',
	availability: "AVAILABLE",
	size: '2,200',
	plan: '8th-floor-nw.png',
	thumbImg: '8th-floor-thumb.jpg',
	img: '8th-floor-img.jpg',
	dl: 'floorplans.pdf'
}, {
	floor: 'Eighth (NE)',
	availability: "AVAILABLE",
	size: '2,124',
	plan: '8th-floor-ne.png',
	thumbImg: '8th-floor-thumb.jpg',
	img: '8th-floor-img.jpg',
	dl: 'floorplans.pdf'
}];

var mapLabels = [{
	label: "45 Jermyn St",
	pos: { lat: 51.508009, lng: -0.138239 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-restaurant.png",
	imgSelected: "restaurantSelected.png",
	type: "restaurant",
	galleryImg: "45-jermyn-st.jpg"
}, {
	label: "The Ritz and The Rivoli",
	pos: { lat: 51.506904, lng: -0.141276 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-hotel.png",
	imgSelected: "hotelSelected.png",
	type: "hotel",
	galleryImg: "the-ritz-restaurant.jpg" /*, {
                                       label: "The Rivoli Bar",
                                       pos: { lat: 51.507304, lng: -0.141354 },
                                       size: { width: 35, height: 35 },
                                       color: "#CE9757",
                                       selectedColor: "#3E3D3C",
                                       img: "icon-bar.png",
                                       imgSelected: "barSelected.png",
                                       pinNumb: 3,
                                       type: "bar",
                                       galleryImg: "the-rivoli-bar.jpg"
                                       }*/ }, {
	label: "Brown's Hotel",
	pos: { lat: 51.509131, lng: -0.142115 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-hotel.png",
	imgSelected: "hotelSelected.png",
	type: "hotel",
	galleryImg: "browns-hotel.jpg"
}, {
	label: "Caviar House & Prunier",
	pos: { lat: 51.507769, lng: -0.140043 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-restaurant.png",
	imgSelected: "restaurantSelected.png",
	type: "restaurant",
	galleryImg: "caviar-house.jpg"
}, {
	label: "Langan's Brasserie",
	pos: { lat: 51.507044, lng: -0.143452 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-restaurant.png",
	imgSelected: "restaurantSelected.png",
	type: "restaurant",
	galleryImg: "langans-brassierie.jpg"
}, {
	label: "Novikov Restaurant",
	pos: { lat: 51.50767, lng: -0.142922 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-restaurant.png",
	imgSelected: "restaurantSelected.png",
	type: "restaurant",
	galleryImg: "novikov-restaurant.jpg"
}, {
	label: "Sexy Fish",
	pos: { lat: 51.509332, lng: -0.144346 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-restaurant.png",
	imgSelected: "restaurantSelected.png",
	type: "restaurant",
	galleryImg: "sexy-fish.jpg"
}, {
	label: "The May Fair Hotel",
	pos: { lat: 51.508159, lng: -0.143902 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-hotel.png",
	imgSelected: "hotelSelected.png",
	type: "hotel",
	galleryImg: "the-may-fair-hotel.jpg"
}, {
	label: "The Arts Club",
	pos: { lat: 51.508329, lng: -0.142357 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-bar.png",
	imgSelected: "barSelected.png",
	type: "bar",
	galleryImg: "the-arts-club.jpg"
}, {
	label: "Berkeley Square",
	pos: { lat: 51.509654, lng: -0.145860 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-featured.png",
	imgSelected: "featuredSelected.png",
	type: "featured",
	galleryImg: "berkeley-square.jpg"
}, {
	label: "Gymkhana",
	pos: { lat: 51.5086, lng: -0.141464 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-restaurant.png",
	imgSelected: "restaurantSelected.png",
	type: "restaurant",
	galleryImg: "gymkhana.jpg"
}, {
	label: "Jack Barclay Bentley",
	pos: { lat: 51.5101, lng: -0.145304 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-featured.png",
	imgSelected: "featuredSelected.png",
	type: "featured",
	galleryImg: "jack-barclay-bentley.jpg"
}, {
	label: "Le Caprice",
	pos: { lat: 51.5064, lng: -0.140638 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-restaurant.png",
	imgSelected: "restaurantSelected.png",
	type: "restaurant",
	galleryImg: "le-caprice.jpg"
}, {
	label: "Nobu",
	pos: { lat: 51.508476, lng: -0.143417 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-restaurant.png",
	imgSelected: "restaurantSelected.png",
	type: "restaurant",
	galleryImg: "nobu.jpg"
}, {
	label: "The Wolseley",
	pos: { lat: 51.507645, lng: -0.140926 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-restaurant.png",
	imgSelected: "restaurantSelected.png",
	type: "restaurant",
	galleryImg: "the-wolseley.jpg"
}, {
	label: "Green Park",
	pos: { lat: 51.5056, lng: -0.1433 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-featured.png",
	imgSelected: "featuredSelected.png",
	type: "featured",
	galleryImg: "green-park.jpg"
}, {
	label: "Bond Street",
	pos: { lat: 51.509862, lng: -0.141802 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-featured.png",
	imgSelected: "featuredSelected.png",
	type: "featured",
	galleryImg: "bond-street.jpg"
}, {
	label: "Joseph",
	pos: { lat: 51.5130399, lng: -0.1480241 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-featured.png",
	imgSelected: "featuredSelected.png",
	type: "featured",
	galleryImg: "joseph.jpg"
}, {
	label: "Louis Vuitton",
	pos: { lat: 51.5119813, lng: -0.1461567 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-featured.png",
	imgSelected: "featuredSelected.png",
	type: "featured",
	galleryImg: "louis-vutton.jpg"
}, {
	label: "Prada",
	pos: { lat: 51.509160, lng: -0.141062 },
	size: { width: 35, height: 35 },
	color: "#CE9757",
	selectedColor: "#3E3D3C",
	img: "icon-featured.png",
	imgSelected: "featuredSelected.png",
	type: "featured",
	galleryImg: "prada.jpg"
}];

var amenityGallery = [{
	img: "45-jermyn-st.jpg"
}, {
	img: "the-ritz-restaurant.jpg" /*, {
                                img: "the-rivoli-bar.jpg"
                                }*/ }, {
	img: "browns-hotel.jpg"
}, {
	img: "caviar-house.jpg"
}, {
	img: "langans-brassierie.jpg"
}, {
	img: "novikov-restaurant.jpg"
}, {
	img: "sexy-fish.jpg"
}, {
	img: "the-may-fair-hotel.jpg"
}, {
	img: "the-arts-club.jpg"
}, {
	img: "berkeley-square.jpg"
}, {
	img: "gymkhana.jpg"
}, {
	img: "jack-barclay-bentley.jpg"
}, {
	img: "le-caprice.jpg"
}, {
	img: "nobu.jpg"
}, {
	img: "the-wolseley.jpg"
}, {
	img: "green-park.jpg"
}, {
	img: "bond-street.jpg"
}, {
	img: "joseph.jpg"
}, {
	img: "louis-vutton.jpg"
}, {
	img: "prada.jpg"
}];

var staticMapLabels = [{
	label: 'Green Park',
	pos: { lat: 51.503901, lng: -0.143834 },
	size: { width: 99, height: 27 },
	img: 'greenpark-label.png'
}, {
	label: 'Golden Square',
	pos: { lat: 51.511639, lng: -0.13718 },
	size: { width: 99, height: 27 },
	img: 'goldensquare-label.png'
}, {
	label: 'Berkeley Square',
	pos: { lat: 51.509639, lng: -0.145877 },
	size: { width: 126, height: 27 },
	img: 'berkeley-label.png'
}, {
	label: 'The Ritz',
	pos: { lat: 51.507, lng: -0.1395 },
	size: { width: 99, height: 27 },
	img: 'theritz-label.png'
}, {
	label: 'Piccadilly Circus',
	pos: { lat: 51.5094, lng: -0.134766 },
	size: { width: 112, height: 27 },
	color: '#0D5071',
	img: 'piccadilly-label.png'
}, {
	label: 'St James Park',
	pos: { lat: 51.503, lng: -0.137 },
	size: { width: 112, height: 27 },
	img: 'StJamesPark.png'
	// {
	// 	label: "Grovesnor Square",
	// 	pos: { lat: 51.5121, lng: -0.1493 },
	// 	size: { width: 112, height: 27 },
	// 	color: "#0D5071",
	// 	selected: 0,
	// 	selectedColor: "#C88F4D",
	// 	img: "GrosvenorSquare.png",
	// 	pinNumb: 7
	// }
}];

var availabilityLabels = [{
	label: '45 Jermyn St',
	pos: { lat: 51.508009, lng: -0.138239 },
	size: { width: 99, height: 27 },
	color: '#CE9757',
	selected: 1,
	selectedColor: '#3E3D3C',
	img: 'icon-restaurant.png',
	imgSelected: 'restaurantSelected.png',
	pinNumb: 1,
	type: 'restaurant'
}];

var availabilityGallery = [{
	img: '8th-floor-1.jpg',
	label: '8th Floor'
}, {
	img: '8th-floor-4.jpg',
	label: '8th Floor'
}, {
	img: '8th-floor-5.jpg',
	label: '8th Floor'
}, {
	img: 'floorplan-2.jpg',
	label: 'CGI Fit out'
}, {
	img: 'floorplan-3.jpg',
	label: 'CGI Fit out'
}, {
	img: 'floorplan-4.png',
	label: 'CGI Fit out'
}, {
	img: 'floorplan-5.jpg',
	label: 'CGI Fit out'
}];

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SiteIntro;
/* harmony export (immutable) */ __webpack_exports__["b"] = HomeIntro;
/* harmony export (immutable) */ __webpack_exports__["e"] = HomeOutro;
/* harmony export (immutable) */ __webpack_exports__["c"] = DefaultPageIntro;
/* harmony export (immutable) */ __webpack_exports__["f"] = DefaultPageOutro;
/* harmony export (immutable) */ __webpack_exports__["g"] = CondensedPageOutro;
/* harmony export (immutable) */ __webpack_exports__["d"] = CondensedPageIntro;
/* harmony export (immutable) */ __webpack_exports__["i"] = BurgerOpen;
/* harmony export (immutable) */ __webpack_exports__["h"] = BurgerClose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs__ = __webpack_require__(0);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



function SiteIntro(params) {
	var introLines = document.querySelectorAll('.logo-line');
	var introMark = document.querySelector('.logo-mark');
	var introWrapper = document.querySelector('.intro-wrapper');
	var homeBg = document.querySelector('.home-video');
	var nav = document.querySelector('.nav');
	var header = document.querySelector('.home-content');
	var mainHeading = document.querySelector('.main-heading');

	var timeline = new __WEBPACK_IMPORTED_MODULE_0_animejs__["a" /* default */].timeline();

	setTimeout(function () {
		timeline.add({
			targets: introLines,
			opacity: {
				value: [0, 1],
				duration: 200
			},
			strokeDashoffset: [__WEBPACK_IMPORTED_MODULE_0_animejs__["a" /* default */].setDashoffset, 0],
			easing: 'easeOutQuad',
			duration: 1000,
			delay: __WEBPACK_IMPORTED_MODULE_0_animejs__["a" /* default */].stagger(300)
		}).add({
			targets: introMark,
			opacity: [0, 1],
			duration: 400,
			easing: 'easeOutQuad'
		}).add({
			targets: introWrapper,
			opacity: [1, 0],
			duration: 800,
			easing: 'easeInQuad',
			delay: 1000
		}).add({
			targets: header,
			opacity: [0, 1],
			duration: 800,
			easing: 'easeOutQuad',
			delay: 400
		}).add({
			targets: nav,
			opacity: [0, 1],
			duration: 400,
			easing: 'easeOutQuad',
			complete: function complete() {
				return introWrapper.classList.add('hidden');
			}
		}).add({
			targets: mainHeading,
			opacity: [1, 1],
			delay: 3000,
			duration: 400,
			easing: 'easeOutQuad',
			complete: function complete() {
				return introWrapper.classList.add('hidden');
			}
		});
	}, 600);
}

function HomeIntro(params) {
	var homeContent = document.querySelector('.home-content');
	var introWrapper = document.querySelector('.intro-wrapper');
	introWrapper.classList.add('hidden');
	var mainHeading = document.querySelector('.main-heading');

	var timeline = new __WEBPACK_IMPORTED_MODULE_0_animejs__["a" /* default */].timeline();
	timeline.add({
		targets: homeContent,
		opacity: [0, 1],
		duration: 400,
		easing: 'easeOutQuad'
	}).add({
		targets: params.nav,
		opacity: [0, 1],
		duration: 400,
		easing: 'easeOutQuad'
	});
	// .add({
	// 	targets: mainHeading,
	// 	opacity: [1, 0],
	// 	delay: 3000,
	// 	duration: 400,
	// 	easing: "easeOutQuad"
	// });
}

function HomeOutro(params) {
	params.homeTransition.classList.remove('hidden');

	var timeline = new __WEBPACK_IMPORTED_MODULE_0_animejs__["a" /* default */].timeline();
	timeline.add({
		targets: params.transitionWipe,
		duration: 400,
		width: '100%',
		easing: 'easeInOutQuad'
	});
}

function DefaultPageIntro(params) {
	var timeline = new __WEBPACK_IMPORTED_MODULE_0_animejs__["a" /* default */].timeline();

	timeline.add({
		targets: params.contentHeaderBlock,
		opacity: [0, 1],
		duration: 400,
		easing: 'easeOutQuad'
	}).add({
		targets: params.nav,
		opacity: [0, 1],
		duration: 400,
		easing: 'easeOutQuad'
	}).add({
		targets: params.fadeElements,
		opacity: [0, 1],
		duration: 400,
		easing: 'easeOutQuad'
	}, '-=200');
}

function DefaultPageOutro(params) {
	var timeline = new __WEBPACK_IMPORTED_MODULE_0_animejs__["a" /* default */].timeline();

	timeline.add({
		targets: params.contentHeaderBlock,
		opacity: [1, 0],
		duration: 200,
		easing: 'easeInQuad'
	}).add({
		targets: [params.content, params.nav, params.fadeElements],
		opacity: [1, 0],
		duration: 200,
		easing: 'easeInQuad'
	}, '-=200');
}

function CondensedPageOutro(params) {
	var timeline = new __WEBPACK_IMPORTED_MODULE_0_animejs__["a" /* default */].timeline();

	timeline.add({
		targets: [params.content, params.nav],
		duration: 400,
		easing: 'easeInQuad',
		opacity: [1, 0]
	});
}

function CondensedPageIntro(params) {
	var timeline = new __WEBPACK_IMPORTED_MODULE_0_animejs__["a" /* default */].timeline();

	timeline.add({
		targets: [].concat(_toConsumableArray(params.content), [params.nav]),
		duration: 400,
		easing: 'easeOutQuad',
		opacity: [0, 1]
	});
}

function BurgerOpen(params) {
	var timeline = new __WEBPACK_IMPORTED_MODULE_0_animejs__["a" /* default */].timeline();

	params.burger.classList.remove('hidden');
	params.burgerIcon.classList.add('burger-close-icon');
	params.navLogo.classList.add('burger-copper-logo');

	timeline.add({
		targets: params.burgerBg,
		width: '100%',
		// opacity: {
		// 	value: [0, 1],
		// 	duration: 100
		// },
		duration: 400,
		easing: 'easeOutQuad'
	}).add({
		targets: params.burgerList,
		opacity: [0, 1],
		duration: 400,
		easing: 'easeOutQuad'
	});
}

function BurgerClose(params) {
	var timeline = new __WEBPACK_IMPORTED_MODULE_0_animejs__["a" /* default */].timeline();

	params.navLogo.classList.remove('burger-copper-logo');
	params.burgerIcon.classList.remove('burger-close-icon');

	timeline.add({
		targets: params.burgerList,
		opacity: [1, 0],
		duration: 100,
		easing: 'easeInQuad'
	}).add({
		targets: params.burgerBg,
		opacity: [1, 0],
		duration: 100,
		easing: 'easeInQuad',
		complete: function complete() {
			params.burgerBg.style.opacity = 1;
			params.burgerBg.style.width = '0px';
			params.burger.classList.add('hidden');
		}
	});
}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = CleanInteriorGallery;
/* harmony export (immutable) */ __webpack_exports__["a"] = InitInteriorGallery;
/* unused harmony export JumpToSlide */
/* harmony export (immutable) */ __webpack_exports__["c"] = NavigateInteriorSlide;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animejs__ = __webpack_require__(0);



var thumbs = [];
var selectedInteriorIndex = 0;
var params = void 0;
var autoPlayInteriorInstance = void 0;
var canAutoplayInterior = true;

//GALLERY STUFF GOES HERE -------------------------------------------------------------------

function CleanInteriorGallery() {
	// canAutoplay = false;
	if (autoPlayInteriorInstance) clearInterval(autoPlayInteriorInstance);
	thumbs = [];
	selectedInteriorIndex = 0;
}

function InitInteriorGallery(_params) {
	params = _params;
	__WEBPACK_IMPORTED_MODULE_0__data__["b" /* availabilityGallery */].map(function (l, i) {
		var d = document.createElement('div');
		d.classList.add('thumb');
		d.onclick = function () {
			JumpToSlide(i);
		};
		params.galleryThumbCont.appendChild(d);
		thumbs.push(d);
	});
	JumpToSlide(selectedInteriorIndex, true);
	canAutoplayInterior = true;
	autoPlayInteriorInstance = setInterval(Autoplay, 5000);
}

function JumpToSlide(i) {
	var keepAutoPlay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	if (keepAutoPlay) {
		canAutoplayInterior = true;
	} else {
		canAutoplayInterior = false;
	}
	//select thumb
	thumbs.map(function (t) {
		return t.classList.remove('thumb-active');
	});
	thumbs[i].classList.add('thumb-active');
	params.galleryTitle.innerHTML = __WEBPACK_IMPORTED_MODULE_0__data__["b" /* availabilityGallery */][i].label;

	selectedInteriorIndex = i;

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_animejs__["a" /* default */])({
		targets: params.galleryImage,
		opacity: [1, 0],
		duration: 400,
		easing: 'easeInOutQuad',
		complete: function complete() {
			params.galleryImage.style.backgroundImage = 'url(images/availabilityGallery/' + __WEBPACK_IMPORTED_MODULE_0__data__["b" /* availabilityGallery */][i].img + ')';
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_animejs__["a" /* default */])({
				targets: params.galleryImage,
				opacity: [0, 1],
				duration: 400,
				easing: 'easeInOutQuad'
			});
		}
	});
}

function NavigateInteriorSlide(_dir) {
	var keepAutoPlay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var dir = 0;
	if (_dir === 'next') {
		dir = +1;
	} else if (_dir === 'prev') {
		dir = -1;
	}

	var newIndex = selectedInteriorIndex + dir;

	if (newIndex > __WEBPACK_IMPORTED_MODULE_0__data__["b" /* availabilityGallery */].length - 1) {
		newIndex = 0;
	} else if (newIndex < 0) {
		newIndex = __WEBPACK_IMPORTED_MODULE_0__data__["b" /* availabilityGallery */].length - 1;
	}

	JumpToSlide(newIndex, keepAutoPlay);
}

function Autoplay() {
	if (canAutoplayInterior) {
		NavigateInteriorSlide('next', true);
	}
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CleanAmenityGallery;
/* harmony export (immutable) */ __webpack_exports__["b"] = InitMap;
/* unused harmony export JumpToSlide */
/* harmony export (immutable) */ __webpack_exports__["c"] = NavigateAmenitySlide;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_load_google_maps_api__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_load_google_maps_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_load_google_maps_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapStyle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_animejs__ = __webpack_require__(0);





var map = void 0;
var gmap = void 0;
var amenityMarkers = [];
var selectedIndex = 0;
var thumbs = [];
var params = void 0;
var canAutoplay = true;
var autoPlayInstance = null;

function CleanAmenityGallery() {
	// canAutoplay = false;
	if (autoPlayInstance) clearInterval(autoPlayInstance);
	thumbs = [];
	amenityMarkers = [];
	selectedIndex = 0;
}

function Autoplay() {
	if (canAutoplay) {
		NavigateAmenitySlide('next', true);
	}
}

//MAP STUFF GOES HERE -------------------------------------------------------------------

function InitMap(_params) {
	//ONLY RUN THIS ONCE
	__WEBPACK_IMPORTED_MODULE_0_load_google_maps_api___default()({ key: 'AIzaSyA5e6sF73xl-ayJigo_o6EdvrcClb-kOys' }).then(function (_gmap) {
		gmap = _gmap;
		params = _params;
		var buildingLocation = new gmap.LatLng(51.507249, -0.142795);
		map = new gmap.Map(params.map, {
			center: buildingLocation,
			styles: __WEBPACK_IMPORTED_MODULE_1__mapStyle__["a" /* style */],
			mapTypeControl: false,
			streetViewControl: false,
			fullscreenControl: false,
			zoom: 16
		});

		var buildingMarkerIcon = {
			url: 'images/map-pin-inverted.png',
			scaledSize: new gmap.Size(58, 67),
			anchor: new gmap.Point(29, 0)
		};

		var buildingMarker = new gmap.Marker({
			position: buildingLocation,
			map: map,
			zIndex: 15,
			icon: buildingMarkerIcon
		});

		var buildingShadeBounds = {
			north: 51.50755,
			south: 51.50685,
			east: -0.1422,
			west: -0.14335
		};

		var buildingShade = new gmap.GroundOverlay('http://p3.sirendev.co.uk/temp/building-shade.png', buildingShadeBounds);
		buildingShade.setMap(map);

		__WEBPACK_IMPORTED_MODULE_2__data__["c" /* staticMapLabels */].map(function (label) {
			var staticLabel = new gmap.Marker({
				position: new gmap.LatLng(label.pos.lat, label.pos.lng),
				map: map,
				icon: {
					url: './images/' + label.img,
					scaledSize: new gmap.Size(label.size.width, label.size.height),
					anchor: new gmap.Point(label.size.width / 2, label.size.height / 2)
				}
			});
		});

		//LATE CALLERS
		PopulateAmenityPins();
		InitAmenityGallery(params);
		JumpToSlide(0, true);
	});
}

function SelectPin(i) {
	selectedIndex = i;
	PopulateAmenityPins();
}

function PopulateAmenityPins() {
	ClearAmenityPins();

	__WEBPACK_IMPORTED_MODULE_2__data__["d" /* mapLabels */].map(function (label, i) {
		var labelPin = new gmap.Marker({
			position: new gmap.LatLng(label.pos.lat, label.pos.lng),
			map: map,
			zIndex: 10,
			icon: {
				url: 'images/' + (i === selectedIndex ? label.imgSelected : label.img),
				scaledSize: new gmap.Size(label.size.width, label.size.height),
				anchor: new gmap.Point(label.size.width / 2, label.size.height / 2)
			}
		});

		labelPin.addListener('click', function () {
			JumpToSlide(i);
		});

		amenityMarkers.push(labelPin);
	});
}

function ClearAmenityPins() {
	amenityMarkers.map(function (m) {
		return m.setMap(null);
	});
}

//GALLERY STUFF GOES HERE -------------------------------------------------------------------
function InitAmenityGallery() {
	__WEBPACK_IMPORTED_MODULE_2__data__["d" /* mapLabels */].map(function (l, i) {
		var d = document.createElement('div');
		d.classList.add('thumb');
		d.onclick = function () {
			JumpToSlide(i);
		};
		params.galleryThumbCont.appendChild(d);
		thumbs.push(d);
	});
	canAutoplay = true;
	autoPlayInstance = setInterval(Autoplay, 5000);
}

function JumpToSlide(i) {
	var keepAutoPlay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	if (keepAutoPlay) {
		canAutoplay = true;
	} else {
		canAutoplay = false;
	}
	SelectPin(i);
	//select thumb
	thumbs.map(function (t) {
		return t.classList.remove('thumb-active');
	});
	thumbs[i].classList.add('thumb-active');
	params.galleryTitle.innerHTML = __WEBPACK_IMPORTED_MODULE_2__data__["d" /* mapLabels */][i].label;

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_animejs__["a" /* default */])({
		targets: params.galleryImage,
		opacity: [1, 0],
		duration: 400,
		easing: 'easeInOutQuad',
		complete: function complete() {
			params.galleryImage.style.backgroundImage = 'url(images/gallery/' + __WEBPACK_IMPORTED_MODULE_2__data__["d" /* mapLabels */][i].galleryImg + ')';
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_animejs__["a" /* default */])({
				targets: params.galleryImage,
				opacity: [0, 1],
				duration: 400,
				easing: 'easeInOutQuad'
			});
		}
	});
}

function NavigateAmenitySlide(_dir) {
	var keepAutoPlay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var dir = 0;
	if (_dir === 'next') {
		dir = +1;
	} else if (_dir === 'prev') {
		dir = -1;
	}

	var newIndex = selectedIndex + dir;

	if (newIndex > __WEBPACK_IMPORTED_MODULE_2__data__["d" /* mapLabels */].length - 1) {
		newIndex = 0;
	} else if (newIndex < 0) {
		newIndex = __WEBPACK_IMPORTED_MODULE_2__data__["d" /* mapLabels */].length - 1;
	}

	JumpToSlide(newIndex, keepAutoPlay);
}

function Autoplay() {
	if (canAutoplay) {
		NavigateAmenitySlide('next', true);
	}
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = InitPlanView;
/* harmony export (immutable) */ __webpack_exports__["b"] = HideOverlay;
/* harmony export (immutable) */ __webpack_exports__["c"] = ZoomIn;
/* harmony export (immutable) */ __webpack_exports__["d"] = ZoomOut;
/* harmony export (immutable) */ __webpack_exports__["e"] = ZoomReset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animejs__ = __webpack_require__(0);



var options = {
	isOverlayOpen: false,
	currentPlan: 0,
	imageDiv: null,
	planThumbs: [],
	selectorDiv: null,
	planTitle: null,
	planDl: null,
	isBusy: false,
	canPan: false,
	overlayDiv: null,
	overlayGreyout: null,
	overlayImg: null,
	zoom: {
		current: 1,
		max: 2,
		min: 0.6,
		default: 1,
		rate: 0.4
	},
	imagePan: {
		deltaX: 0,
		deltaY: 0,
		drag: {
			elem: null,
			x: 0,
			y: 0,
			state: false
		},
		delta: {
			x: 0,
			y: 0
		}
	}
};

function InitPlanView(params) {
	CleanUpPlanView();
	if (params.floorPlanView !== undefined && params.floorPlanView) {
		CleanUpPlanView();
		options.imageDiv = params.floorPlanView.querySelector(".floor-plan-img");
		options.planTitle = params.floorPlanView.querySelector(".floor-plan-heading");
		options.selectorDiv = params.floorSelector;
		options.selectorDiv.innerHTML = "";

		options.overlayDiv = params.overlay;
		options.overlayImg = params.overlay.querySelector(".overlay-image");
		options.overlayGreyout = params.overlay.querySelector(".overlay-greyout");

		options.planTitle = params.floorPlanView.querySelector(".floor-plan-heading");
		options.planDl = params.floorPlanView.querySelector(".download-plan-link");

		__WEBPACK_IMPORTED_MODULE_0__data__["a" /* availFloors */].map(function (floor, i) {
			var li = document.createElement("li");
			li.classList.add("floor-selector");
			li.addEventListener("click", function () {
				return JumpToPlan(i);
			});
			// const floorImgDiv = document.createElement("div");
			// floorImgDiv.classList.add("floor-selector-img");
			// floorImgDiv.style.backgroundImage = `url(./images/${floor.thumbImg})`;
			// floorImgDiv.style.backgroundSize = "cover";
			var floorSelectorContentDiv = document.createElement("div");
			floorSelectorContentDiv.classList.add("floor-selector-content");
			floorSelectorContentDiv.innerHTML = "<div class=\"floor-selector-text\">" + floor.floor.toUpperCase() + " FLOOR </div>\n            <div class=\"floor-selector-text dark-text\">" + floor.size + " SQ FT</div> <div class=\"floor-selector-text dark-text\">" + floor.availability + "</div>";
			var galleryIconDiv = document.createElement("div");
			// galleryIconDiv.classList.add("floor-gallery-icon");
			// galleryIconDiv.addEventListener("click", () => ShowOverlay(i));
			// li.appendChild(floorImgDiv);
			li.appendChild(floorSelectorContentDiv);
			// li.appendChild(galleryIconDiv);
			options.selectorDiv.appendChild(li);
			options.planThumbs.push(li);
		});

		options.canPan = true;
		options.imagePan.drag.elem = options.imageDiv;

		options.imageDiv.addEventListener("mousedown", DragStart);
		options.imageDiv.addEventListener("mousemove", IsDragging);
		document.addEventListener("mouseup", DragStop);

		JumpToPlan(options.currentPlan);
	}
}

function JumpToPlan(index) {
	options.currentPlan = index;

	options.planThumbs.map(function (thumb) {
		return thumb.classList.remove("floor-selector-active");
	});
	options.planThumbs[index].classList.add("floor-selector-active");
	options.imageDiv.style.backgroundImage = "url(./images/floorplans/" + __WEBPACK_IMPORTED_MODULE_0__data__["a" /* availFloors */][index].plan + ")";

	options.planTitle.innerHTML = __WEBPACK_IMPORTED_MODULE_0__data__["a" /* availFloors */][index].floor.toUpperCase() + " FLOOR <br /><span class=\"dark-text\">PLAN</span>";
	options.planDl.href = "dl/" + __WEBPACK_IMPORTED_MODULE_0__data__["a" /* availFloors */][index].dl;
}

function ShowOverlay(index) {
	if (options.isBusy) {
		return;
	}
	options.isBusy = true;
	options.overlayImg.style.backgroundImage = "url(./images/" + __WEBPACK_IMPORTED_MODULE_0__data__["a" /* availFloors */][index].img + ")";
	options.overlayImg.style.backgroundSize = "cover";
	options.overlayDiv.classList.remove("hidden");

	var timeline = new __WEBPACK_IMPORTED_MODULE_1_animejs__["a" /* default */].timeline();

	timeline.add({
		targets: options.overlayGreyout,
		opacity: [0, 0.7],
		duration: 200,
		easing: "easeOutQuad"
	}).add({
		targets: options.overlayImg,
		opacity: [0, 1],
		duration: 200,
		easing: "easeOutQuad",
		complete: function complete() {
			options.isBusy = false;
		}
	});
}

function HideOverlay() {
	if (options.isBusy) {
		return;
	}
	options.isBusy = true;
	var timeline = new __WEBPACK_IMPORTED_MODULE_1_animejs__["a" /* default */].timeline();

	timeline.add({
		targets: options.overlayImg,
		opacity: [1, 0],
		duration: 200,
		easing: "easeInQuad"
	}).add({
		targets: options.overlayGreyout,
		opacity: [0.7, 0],
		duration: 200,
		easing: "easeInQuad",
		complete: function complete() {
			options.overlayDiv.classList.add("hidden");
			options.isBusy = false;
		}
	}, 0);
}

function CleanUpPlanView() {
	options.canPan = false;
	if (options.selectorDiv !== null) {
		options.selectorDiv.innerHTML = "";
		options.selectorDiv = null;
	}
	options.planThumbs = [];
}

function ZoomIn() {
	if (options.isBusy) {
		return;
	}

	if (options.zoom.current + options.zoom.rate > options.zoom.max) {
		return;
	}

	options.isBusy = true;
	options.zoom.current = options.zoom.current + options.zoom.rate;

	ZoomAnim();
}

function ZoomOut() {
	if (options.isBusy) {
		return;
	}

	if (options.zoom.current - options.zoom.rate < options.zoom.min) {
		return;
	}

	options.isBusy = true;
	options.zoom.current = options.zoom.current - options.zoom.rate;

	ZoomAnim();
}

function ZoomReset() {
	if (options.isBusy) {
		return;
	}

	options.isBusy = true;
	options.zoom.current = options.zoom.default;

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_animejs__["a" /* default */])({
		targets: options.imageDiv,
		top: "0px",
		left: "0px",
		easing: "easeInOutQuad",
		duration: 200,
		complete: function complete() {
			options.imageDiv.style.top = "0px";
			options.imageDiv.style.left = "0px";
		}
	});

	ZoomAnim();
}

function ZoomAnim() {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_animejs__["a" /* default */])({
		targets: options.imageDiv,
		scale: options.zoom.current,
		duration: 200,
		easing: "easeOutQuad",
		complete: function complete() {
			options.isBusy = false;
		}
	});
}

function DragStart(e) {
	if (!options.imagePan.drag.state && e.which === 1) {
		if (e.target.classList[0] === options.imageDiv.classList[0]) {
			options.imagePan.drag.elem = options.imageDiv;
		} else {
			return;
		}
		options.imagePan.drag.x = e.pageX;
		options.imagePan.drag.y = e.pageY;
		options.imagePan.drag.state = true;
	}
	return false;
}

function IsDragging(e) {
	if (options.imagePan.drag.state) {
		options.imagePan.delta.x = e.pageX - options.imagePan.drag.x;
		options.imagePan.delta.y = e.pageY - options.imagePan.drag.y;

		var imagePanStyle = {
			left: options.imagePan.drag.elem.style.left.substr(0, options.imagePan.drag.elem.style.left.length - 2),
			top: options.imagePan.drag.elem.style.top.substr(0, options.imagePan.drag.elem.style.top.length - 2)
		};

		options.imagePan.drag.elem.style.left = parseInt(imagePanStyle.left) + options.imagePan.delta.x + "px";
		options.imagePan.drag.elem.style.top = parseInt(imagePanStyle.top) + options.imagePan.delta.y + "px";

		options.imagePan.drag.x = e.pageX;
		options.imagePan.drag.y = e.pageY;

		options.imagePan.drag.elem.style.cursor = "grabbing";
	}
}

function DragStop() {
	if (options.imagePan.drag.state) {
		options.imagePan.drag.state = false;
		options.imagePan.drag.elem.style.cursor = "grab";
	}
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["GetPageName"] = GetPageName;
/* harmony export (immutable) */ __webpack_exports__["NavigateSlide"] = NavigateSlide;
/* harmony export (immutable) */ __webpack_exports__["NavigateAmenitySlideHandler"] = NavigateAmenitySlideHandler;
/* harmony export (immutable) */ __webpack_exports__["NavigateInteriorSlideHandler"] = NavigateInteriorSlideHandler;
/* harmony export (immutable) */ __webpack_exports__["CloseOverlayHandler"] = CloseOverlayHandler;
/* harmony export (immutable) */ __webpack_exports__["ZoomHandler"] = ZoomHandler;
/* harmony export (immutable) */ __webpack_exports__["ToggleBurger"] = ToggleBurger;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__anims__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__planView__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapGallery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interiorGallery__ = __webpack_require__(3);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







var params = {};
var firstTime = true;
var isBurgerOpen = false;
var map = null;

Init();
PageInit(GetPageName());

window.addEventListener('scroll', function (e) {
	if (params.parallaxImages.length > 0) {
		params.parallaxImages.map(function (img) {
			return ParallaxScroll(img);
		});
	}
});

function Init() {
	$('#main').smoothState({
		debug: true,
		prefetch: true,
		cacheLength: 4,
		onStart: {
			duration: 600,
			render: function render($container) {
				QueryParams();
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__mapGallery__["a" /* CleanAmenityGallery */])();
				var pageName = GetPageName();
				params.pageName = pageName;
				console.log(pageName);
				//outro goes here
				OutroAnim(pageName);
			}
		},
		onAfter: function onAfter($container, $newContent) {
			var pageName = GetPageName();
			params.pageName = pageName;
			QueryParams();
			//intro goes here
			PageInit(pageName);
		}
	});
}

function QueryParams() {
	params = {
		main: document.querySelector('.main'),
		homeTransition: document.querySelector('.home-transition'),
		transitionWipe: document.querySelector('.transition-wipe'),
		nav: document.querySelector('.nav'),
		contentHeaderBlock: document.querySelector('.content-header-block'),
		fadeElements: [].concat(_toConsumableArray(document.querySelectorAll('.fade'))),
		content: document.querySelector('.content'),
		parallaxImages: [].concat(_toConsumableArray(document.querySelectorAll('.parallax'))),
		map: document.querySelector('.map'),
		gallery: document.querySelector('.gallery'),
		galleryImage: document.querySelector('.gallery-image'),
		galleryTitle: document.querySelector('.slide-heading'),
		galleryThumbCont: document.querySelector('.thumb-container'),
		floorSelector: document.querySelector('.floor-selector-list'),
		floorPlanView: document.querySelector('.floor-plan-view'),
		overlay: document.querySelector('.overlay'),
		burger: document.querySelector('.burger'),
		burgerIcon: document.querySelector('.nav-item-burger'),
		burgerBg: document.querySelector('.burger-bg'),
		burgerList: document.querySelector('.burger-list'),
		burgerButton: document.querySelector('.nav-item-burger'),
		navLogo: document.querySelector('.nav-item-logo')
	};
}

function GetPageName() {
	var rawName = window.location.pathname.split('/').pop();
	var pageName = rawName.split('.').shift();
	if (pageName === '') pageName = 'index';
	return pageName;
}

function PageInit(_page) {
	//intro anims and stuff go here
	QueryParams();
	// InitAmenityGallery(params);
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__planView__["a" /* InitPlanView */])(params);

	switch (_page) {
		case 'index':
			if (firstTime) {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__anims__["a" /* SiteIntro */])(params);
				firstTime = false;
			} else {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__anims__["b" /* HomeIntro */])(params);
			}
			return;
		case 'building':
		case 'location':
			firstTime = false;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__anims__["c" /* DefaultPageIntro */])(params);
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__mapGallery__["b" /* InitMap */])(params);
			// InitMap(params);
			return;
		case 'contact':
			firstTime = false;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__anims__["c" /* DefaultPageIntro */])(params);
			return;
		case 'concierge':
		case 'floor-plans':
			firstTime = false;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__anims__["d" /* CondensedPageIntro */])(params);
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__interiorGallery__["a" /* InitInteriorGallery */])(params);
			return;
		case 'specification':
			firstTime = false;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__anims__["d" /* CondensedPageIntro */])(params);
			return;
	}
}

function OutroAnim(_page) {
	QueryParams();
	//outro anim fires here
	switch (_page) {
		case 'index':
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__anims__["e" /* HomeOutro */])(params);
			return;
		case 'location':
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__mapGallery__["a" /* CleanAmenityGallery */])();
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__anims__["f" /* DefaultPageOutro */])(params);
			return;
		case 'building':
		case 'contact':
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__anims__["f" /* DefaultPageOutro */])(params);
			return;
		case 'concierge':
		case 'floor-plans':
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__interiorGallery__["b" /* CleanInteriorGallery */])();
			return;
		case 'specification':
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__anims__["g" /* CondensedPageOutro */])(params);
			return;
	}
}

function NavigateSlide(dir) {
	NavigateGallery(dir);
}

function NavigateAmenitySlideHandler(dir) {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__mapGallery__["c" /* NavigateAmenitySlide */])(dir);
}

function NavigateInteriorSlideHandler(dir) {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__interiorGallery__["c" /* NavigateInteriorSlide */])(dir);
}

function CloseOverlayHandler() {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__planView__["b" /* HideOverlay */])();
}

function ParallaxScroll(img) {
	img.style.backgroundPosition = '50% ' + -img.getBoundingClientRect().y / 3 + 'px'; //was 3
}

function ZoomHandler(dir) {
	switch (dir) {
		case 'in':
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__planView__["c" /* ZoomIn */])();
			return;
		case 'out':
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__planView__["d" /* ZoomOut */])();
			return;
		case 'reset':
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__planView__["e" /* ZoomReset */])();
			return;
	}
}

function ToggleBurger() {
	if (isBurgerOpen) {
		isBurgerOpen = false;
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__anims__["h" /* BurgerClose */])(params);
	} else {
		isBurgerOpen = true;
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__anims__["i" /* BurgerOpen */])(params);
	}
}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return style; });

var style = [{
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [{
        "color": "#444444"
    }]
}, {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [{
        "color": "#f9f3ec"
    }]
}, {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [{
        "visibility": "simplified"
    }]
}, {
    "featureType": "poi.attraction",
    "elementType": "all",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "poi.business",
    "elementType": "all",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "poi.government",
    "elementType": "all",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "poi.medical",
    "elementType": "all",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "poi.park",
    "elementType": "geometry.fill",
    "stylers": [{
        "color": "#ddffd6"
    }]
}, {
    "featureType": "poi.place_of_worship",
    "elementType": "all",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "poi.school",
    "elementType": "all",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "poi.sports_complex",
    "elementType": "all",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{
        "saturation": -100
    }, {
        "lightness": 45
    }]
}, {
    "featureType": "road",
    "elementType": "geometry.fill",
    "stylers": [{
        "color": "#e9d7c1"
    }]
}, {
    "featureType": "road",
    "elementType": "geometry.stroke",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "road",
    "elementType": "labels.text.fill",
    "stylers": [{
        "color": "#b1650d"
    }]
}, {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [{
        "visibility": "simplified"
    }]
}, {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [{
        "visibility": "simplified"
    }]
}, {
    "featureType": "water",
    "elementType": "all",
    "stylers": [{
        "color": "#9bd7ef"
    }, {
        "visibility": "on"
    }]
}];

/***/ }),
/* 8 */
/***/ (function(module, exports) {

var CALLBACK_NAME = '__googleMapsApiOnLoadCallback'

var OPTIONS_KEYS = ['channel', 'client', 'key', 'language', 'region', 'v']

var promise = null

module.exports = function (options) {
  options = options || {}

  if (!promise) {
    promise = new Promise(function (resolve, reject) {
      // Reject the promise after a timeout
      var timeoutId = setTimeout(function () {
        window[CALLBACK_NAME] = function () {} // Set the on load callback to a no-op
        reject(new Error('Could not load the Google Maps API'))
      }, options.timeout || 10000)

      // Hook up the on load callback
      window[CALLBACK_NAME] = function () {
        if (timeoutId !== null) {
          clearTimeout(timeoutId)
        }
        resolve(window.google.maps)
        delete window[CALLBACK_NAME]
      }

      // Prepare the `script` tag to be inserted into the page
      var scriptElement = document.createElement('script')
      var params = ['callback=' + CALLBACK_NAME]
      OPTIONS_KEYS.forEach(function (key) {
        if (options[key]) {
          params.push(key + '=' + options[key])
        }
      })
      if (options.libraries && options.libraries.length) {
        params.push('libraries=' + options.libraries.join(','))
      }
      scriptElement.src =
        'https://maps.googleapis.com/maps/api/js?' + params.join('&')

      // Insert the `script` tag
      document.body.appendChild(scriptElement)
    })
  }

  return promise
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build/js/bundle.js